import React, { Component } from 'react';
import axiosInstance from '../axiosApi';
import { Tooltip } from 'antd';
import { Select } from 'antd';
import { store } from '../redux/store'



const { Option } = Select;

type Props = {
  branch_id: number,
  onChange: (key: string, value: any) => void,
};
type State = {
  selected?: any[],
  items: any[];
  branchID: number,
  loading: boolean,
};

function decode_token_extra_data(token: string) {
  // NOTE token argument ignored for now
  const access_token = localStorage.getItem("access_token") || "";
  // split token  (base64) into header, payload and (opt) signature
  const [header_base64, payload_base64] = access_token.split(".");

  // convert data from base64 back into regular string
  const payload_json = atob(payload_base64);
  // return just the "exd" field in the token json
  // and discard other data (exd shall be a subobj as defined in backend admin)
  return (JSON.parse(payload_json).exd);
}

class ExGroupOption extends Component<Props, State> {
  state: State = {
    selected: [],
    items: [],
    branchID: 0,
    loading: true
  };

  clearFields() {
    console.log("clearing!");
    this.setState({
      selected: undefined
    });
  }

  componentDidMount() {
    this.load();
  }

  handleChange = (e: any) => {
    console.log(e);
    this.setState({
      selected: e,
    });

    // send our selected group values back up to the parent to handle--like an adult
    this.props.onChange("ex_groups", e);
  };

  load = () => {
    if (this.props.branch_id !== undefined) {
      try {
        // updating to new group values needs to force a blanking to the parents selection
        this.props.onChange("ex_groups", []);

        let payload = {
          "branch_id": this.props.branch_id
        };

        const default_exclude_groups = decode_token_extra_data("");
        console.log(default_exclude_groups.excgroups);

        this.setState({
          loading: true,
          selected: default_exclude_groups.excgroups || []
        });

        store.dispatch({                      // sending value true when component is called, so that the button in EmpList gets disabled
          type: "ISLOADING_Ex_Group",
          payload: true
        });

        axiosInstance.post('shout/groups/', payload)
          .then(res => {
            const obj = res.data.groups;
            this.setState({
              items: obj,
              loading: false
            });

            this.props.onChange("ex_groups", this.state.selected);

            store.dispatch({                        // this is sending false to store component, and enables the button along with other components
              type: "ISLOADING_Ex_Group",
              payload: this.state.loading
            });

          });
      } catch (error) {
        console.log("Error Loading Ex Groups: ", JSON.stringify(error, null, 4));
      }
    }
  };

  componentDidUpdate(prevProps: Props) {
    if (this.props.branch_id !== prevProps.branch_id) {
      this.load();
    }
  }

  render() {
    const options = this.state.items.map((d: any) => <Option value={d.group_id} key={d.group_id}>{d.group_name}</Option>);
    return (
      <div>
        <Tooltip placement="top" title="Example: An employee in Group A and B and you Select Group A above and Group B in the exclude, the employee will be excluded.">
          <span>
            <Select
              mode="multiple"
              placeholder="Select Exclusion Groups"
              onChange={this.handleChange}
              filterOption={(input, option) => option?.props?.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
              optionFilterProp="children"
              value={this.state.selected}
              loading={this.state.loading}
              style={{ width: '100%' }}
              allowClear
              disabled={this.state.loading}
            >
              {options}
            </Select>
          </span>
        </Tooltip>
      </div>
    );
  }
}

export default ExGroupOption;
